import { SVGMotionProps, motion } from 'framer-motion';

export const CodeTagIcon = () => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.78 4L10.22 20"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18 8L22 12L18 16"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6 16L2 12L6 8"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const StepsAnalysisIcon = () => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.49812 8.99875H4.49687C3.6681 8.99875 2.99625 8.3269 2.99625 7.49813V4.49688C2.99625 3.6681 3.6681 2.99625 4.49687 2.99625H7.49812C8.32689 2.99625 8.99875 3.6681 8.99875 4.49688V7.49813C8.99875 8.3269 8.32689 8.99875 7.49812 8.99875Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.5031 8.99875H13.5006C12.6719 8.99875 12 8.3269 12 7.49813V4.49688C12 3.6681 12.6719 2.99625 13.5006 2.99625H19.5031C20.3319 2.99625 21.0037 3.6681 21.0037 4.49688V7.49813C21.0037 8.3269 20.3319 8.99875 19.5031 8.99875Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.5708 13.5006L7.24701 17.7334L5.82742 16.3118"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.35548 12.4292H5.48728C4.11152 12.4292 2.99625 13.5445 2.99625 14.9202V18.5127C2.99625 19.8885 4.11152 21.0037 5.48728 21.0037H9.07978C10.4555 21.0037 11.5708 19.8885 11.5708 18.5127V17.7884"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.5031 18.0025H16.5019C15.6731 18.0025 15.0013 17.3306 15.0013 16.5019V13.5006C15.0013 12.6719 15.6731 12 16.5019 12H19.5031C20.3319 12 21.0038 12.6719 21.0038 13.5006V16.5019C21.0038 17.3306 20.3319 18.0025 19.5031 18.0025Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const StepsDesignIcon = () => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M17 18.2501C17.4142 18.2501 17.75 18.5859 17.75 19.0001C17.75 19.3798 17.4678 19.6936 17.1018 19.7432L17 19.7501L6.99999 19.75C6.58578 19.75 6.25 19.4142 6.25 19C6.25 18.6203 6.53216 18.3065 6.89824 18.2568L7.00001 18.25L17 18.2501Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.8232 16.256L19 16.25C20.4425 16.25 21.6369 17.3643 21.744 18.8232L21.75 19C21.75 20.4425 20.6357 21.6369 19.1768 21.744L19 21.75C17.5575 21.75 16.3631 20.6357 16.256 19.1768L16.25 19C16.25 17.5575 17.3643 16.3631 18.8232 16.256ZM19 17.75L18.9059 17.7535C18.2567 17.8013 17.75 18.3445 17.7495 18.9725L17.7535 19.0941C17.8013 19.7433 18.3445 20.25 18.9725 20.2505L19.0941 20.2465C19.7433 20.1987 20.25 19.6555 20.2505 19.0275L20.2465 18.9059C20.1987 18.2567 19.6555 17.75 19 17.75Z"
			fill="currentColor"
		/>
		<path
			d="M17 4.25005C17.4142 4.25005 17.75 4.58584 17.75 5.00005C17.75 5.37975 17.4678 5.69354 17.1018 5.7432L17 5.75005L7 5.75C6.58578 5.75 6.25 5.41421 6.25 5C6.25 4.6203 6.53216 4.30651 6.89823 4.25685L7 4.25L17 4.25005Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.8232 2.25599L19 2.25C20.4425 2.25 21.6369 3.36428 21.744 4.82319L21.75 5C21.75 6.4425 20.6357 7.63689 19.1768 7.74401L19 7.75C17.5575 7.75 16.3631 6.63572 16.256 5.17681L16.25 5C16.25 3.5575 17.3643 2.36311 18.8232 2.25599ZM19 3.75L18.9059 3.75345C18.2567 3.80135 17.75 4.34451 17.7495 4.97245L17.7535 5.09408C17.8013 5.74327 18.3445 6.25 18.9725 6.25051L19.0941 6.24655C19.7433 6.19865 20.25 5.65549 20.2505 5.02755L20.2465 4.90592C20.1987 4.25673 19.6555 3.75 19 3.75Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.82319 2.25599L5 2.25C6.4425 2.25 7.63689 3.36428 7.74401 4.82319L7.75 5C7.75 6.4425 6.63572 7.63689 5.17681 7.74401L5 7.75C3.5575 7.75 2.36311 6.63572 2.25599 5.17681L2.25 5C2.25 3.5575 3.36428 2.36311 4.82319 2.25599ZM5 3.75L4.90592 3.75345C4.25673 3.80135 3.75 4.34451 3.74949 4.97245L3.75345 5.09408C3.80135 5.74327 4.34451 6.25 4.97245 6.25051L5.09408 6.24655C5.74327 6.19865 6.25 5.65549 6.25051 5.02755L6.24655 4.90592C6.19865 4.25673 5.65549 3.75 5 3.75Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.82319 16.256L5 16.25C6.4425 16.25 7.63689 17.3643 7.74401 18.8232L7.75 19C7.75 20.4425 6.63572 21.6369 5.17681 21.744L5 21.75C3.5575 21.75 2.36311 20.6357 2.25599 19.1768L2.25 19C2.25 17.5575 3.36428 16.3631 4.82319 16.256ZM5 17.75L4.90592 17.7535C4.25673 17.8013 3.75 18.3445 3.74949 18.9725L3.75345 19.0941C3.80135 19.7433 4.34451 20.25 4.97245 20.2505L5.09408 20.2465C5.74327 20.1987 6.25 19.6555 6.25051 19.0275L6.24655 18.9059C6.19865 18.2567 5.65549 17.75 5 17.75Z"
			fill="currentColor"
		/>
		<path
			d="M5.00005 6.25C5.37975 6.25 5.69354 6.53216 5.7432 6.89823L5.75005 7L5.75 17C5.75 17.4142 5.41421 17.75 5 17.75C4.6203 17.75 4.30651 17.4678 4.25685 17.1018L4.25 17L4.25005 7C4.25005 6.58578 4.58584 6.25 5.00005 6.25Z"
			fill="currentColor"
		/>
		<path
			d="M19.0001 6.25C19.3798 6.25 19.6935 6.53216 19.7432 6.89824L19.7501 7.00001L19.75 17C19.75 17.4142 19.4142 17.75 18.9999 17.75C18.6203 17.75 18.3065 17.4678 18.2568 17.1018L18.25 17L18.2501 6.99999C18.2501 6.58578 18.5858 6.25 19.0001 6.25Z"
			fill="currentColor"
		/>
		<path
			d="M14 11.25C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.3797 14.4678 12.6935 14.1018 12.7432L14 12.75H10C9.58579 12.75 9.25 12.4142 9.25 12C9.25 11.6203 9.53215 11.3065 9.89823 11.2568L10 11.25H14Z"
			fill="currentColor"
		/>
		<path
			d="M12 9.25C12.3797 9.25 12.6935 9.53215 12.7432 9.89823L12.75 10V14C12.75 14.4142 12.4142 14.75 12 14.75C11.6203 14.75 11.3065 14.4678 11.2568 14.1018L11.25 14V10C11.25 9.58579 11.5858 9.25 12 9.25Z"
			fill="currentColor"
		/>
	</svg>
);

export const StepsCodeIcon = () => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M20 10V12.5C20 13.3284 19.3284 14 18.5 14H5.5C4.67157 14 4 13.3284 4 12.5V5C4 3.89543 4.89543 3 6 3H9"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.9991 21H5.00094C4.37346 21 3.78237 20.7055 3.40449 20.2045C3.02661 19.7036 2.90578 19.0543 3.07813 18.451L4.14244 14.7253C4.26509 14.296 4.65749 14 5.104 14H18.896C19.3425 14 19.7349 14.296 19.8575 14.7253L20.9219 18.451C21.0942 19.0543 20.9734 19.7036 20.5955 20.2045C20.2176 20.7055 19.6265 21 18.9991 21Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10 18H14"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15 7L13 5L15 3"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18 3L20 5L18 7"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const StepsTestingIcon = () => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.835 15L16.835 20C17.663 20.828 19.007 20.828 19.835 20V20C20.663 19.172 20.663 17.828 19.835 17L14.835 12"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.916 5.84718C20.94 5.87018 20.958 5.90018 20.967 5.93218C21.437 7.49918 21.073 9.26218 19.835 10.5002C18.584 11.7512 16.797 12.1092 15.218 11.6172L6.87099 19.9642C6.05799 20.7772 4.73199 20.8382 3.89099 20.0542C3.00699 19.2312 2.98899 17.8472 3.83499 17.0002L12.218 8.61718C11.726 7.03818 12.084 5.25118 13.335 4.00018C14.573 2.76218 16.336 2.39818 17.903 2.86818C17.935 2.87818 17.965 2.89518 17.988 2.91918L18.15 3.08118C18.228 3.15918 18.228 3.28618 18.15 3.36418L15.515 6.00018L17.835 8.32018L20.471 5.68418C20.549 5.60618 20.676 5.60618 20.754 5.68418L20.916 5.84718V5.84718Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.933 4.29296L3.607 6.31596C3.743 6.72496 4.125 6.99996 4.556 6.99996H6.835V4.72096C6.835 4.29096 6.56 3.90796 6.151 3.77196L4.128 3.09796C3.948 3.03796 3.75 3.08496 3.616 3.21896L3.054 3.78096C2.92 3.91496 2.873 4.11296 2.933 4.29296V4.29296Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.84 7L10.34 10.5"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const StepsEndIcon = () => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.99667 3.99707H14.0008C14.5533 3.99707 15.0013 4.44497 15.0013 4.99749V20.0037H3.99667C3.44415 20.0037 2.99625 19.5558 2.99625 19.0033V4.99749C2.99625 4.44497 3.44415 3.99707 3.99667 3.99707Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.0013 7.99805H20.0033C20.5558 7.99805 21.0038 8.44595 21.0038 8.99846V19.0026C21.0038 19.5551 20.5558 20.003 20.0033 20.003H15.0013V7.99805Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.99792 7.8732C6.92885 7.8732 6.87286 7.92919 6.87286 7.99826C6.87286 8.06732 6.92885 8.12331 6.99792 8.12331C7.06698 8.12331 7.12297 8.06732 7.12297 7.99826C7.12297 7.92919 7.06698 7.8732 6.99792 7.8732"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.9996 7.8732C10.9305 7.8732 10.8745 7.92919 10.8745 7.99826C10.8745 8.06732 10.9305 8.12331 10.9996 8.12331C11.0686 8.12331 11.1246 8.06732 11.1246 7.99826C11.1246 7.92919 11.0686 7.8732 10.9996 7.8732"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.99792 11.8752C6.92885 11.8752 6.87286 11.9311 6.87286 12.0002C6.87286 12.0693 6.92885 12.1253 6.99792 12.1253C7.06698 12.1253 7.12297 12.0693 7.12297 12.0002C7.12297 11.9311 7.06698 11.8752 6.99792 11.8752"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.9996 11.8752C10.9305 11.8752 10.8745 11.9311 10.8745 12.0002C10.8745 12.0693 10.9305 12.1253 10.9996 12.1253C11.0686 12.1253 11.1246 12.0693 11.1246 12.0002C11.1246 11.9311 11.0686 11.8752 10.9996 11.8752"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.99792 15.8771C6.92885 15.8771 6.87286 15.9331 6.87286 16.0022C6.87286 16.0712 6.92885 16.1272 6.99792 16.1272C7.06698 16.1272 7.12297 16.0712 7.12297 16.0022C7.12297 15.9331 7.06698 15.8771 6.99792 15.8771"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.9996 15.8771C10.9305 15.8771 10.8745 15.9331 10.8745 16.0022C10.8745 16.0712 10.9305 16.1272 10.9996 16.1272C11.0686 16.1272 11.1246 16.0712 11.1246 16.0022C11.1246 15.9331 11.0686 15.8771 10.9996 15.8771"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18.0025 11.8752C17.9334 11.8752 17.8774 11.9311 17.8774 12.0002C17.8774 12.0693 17.9334 12.1253 18.0025 12.1253C18.0716 12.1253 18.1275 12.0693 18.1275 12.0002C18.1275 11.9311 18.0716 11.8752 18.0025 11.8752"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M18.0025 15.8771C17.9334 15.8771 17.8774 15.9331 17.8774 16.0022C17.8774 16.0712 17.9334 16.1272 18.0025 16.1272C18.0716 16.1272 18.1275 16.0712 18.1275 16.0022C18.1275 15.9331 18.0716 15.8771 18.0025 15.8771"
			stroke="#323232"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const StepsRadiusArrowsTopLeft = (
	props: SVGMotionProps<SVGPathElement>
) => (
	<svg
		width={294}
		height={136}
		viewBox="0 0 294 136"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="top-left"
	>
		<motion.path
			d="M1 134.541C67 19.5379 134.105 -3.77232 293 3.00222"
			{...props}
		/>
	</svg>
);

export const StepsRadiusArrowsTopRight = (
	props: SVGMotionProps<SVGPathElement>
) => (
	<svg
		width="296"
		height="135"
		viewBox="0 0 296 135"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="top-right"
	>
		<motion.path
			d="M1.00081 2.87028C186.494 -6.4255 235.131 38.1604 294.498 134.002"
			{...props}
		/>
	</svg>
);

export const StepsRadiusArrowsBottomRight = (
	props: SVGMotionProps<SVGPathElement>
) => (
	<svg
		width={294}
		height={135}
		viewBox="0 0 294 135"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="bottom-right"
	>
		<motion.path
			d="M293 0.999771C227 116.003 159.895 139.313 1 132.539"
			{...props}
		/>
	</svg>
);

export const StepsRadiusArrowsBottomLeft = (
	props: SVGMotionProps<SVGPathElement>
) => (
	<svg
		width={295}
		height={135}
		viewBox="0 0 295 135"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="bottom-left"
	>
		<motion.path
			d="M294.42 132.314C108.927 141.61 60.29 97.0242 0.922751 1.18274"
			{...props}
		/>
	</svg>
);

export * from 'react-icons/fi';
